/**
 * Utility functions for formatting values
 */

/**
 * Format a number as currency with commas and decimal points
 * @param {number|string} value - The value to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @param {string} currency - Currency symbol (default: $)
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (value, decimals = 2, currency = '$') => {
  // Handle null, undefined or empty values
  if (value === null || value === undefined || value === '') {
    return `${currency}0.00`;
  }
  
  // Convert to number if it's a string
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return `${currency}0.00`;
  }
  
  // Format the number with commas and decimal points
  return `${currency}${numValue.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })}`;
};
